import axios from 'axios'
import { auth } from '../../api'

// JWT endpoint is at /api/jwt/, not under /auth/api/
const baseUrl = process.env.REACT_APP_AUTH_API?.replace('/auth/api', '') || ''
const authUrl = `${baseUrl}/api/jwt/`

const apiUrl = auth

export function loadToken(user) {
  return axios.post(`${authUrl}token/`, user)
}

export function refreshToken(token) {
  return axios.post(`${authUrl}token/refresh/`, token)
}

export function addUser(data) {
  return axios.post(`${apiUrl}/user`, data)
}

export function updateUser(id, data) {
  return axios.put(`${apiUrl}/user/details/${id}`, data)
}

export function updateUserActive(id) {
  return axios.put(`${apiUrl}/user/active/${id}`)
}

export function updateUserNotActive(id) {
  return axios.put(`${apiUrl}/user/not/active/${id}`)
}

export function updatePassword(id, data, headers) {
  return axios.put(`${apiUrl}/user/password/${id}`, data, headers)
}

export function loadUser(user) {
  return axios.get(`${apiUrl}/user/${user}`)
}

export function loadUserGroups() {
  return axios.get(`${apiUrl}/group`)
}

export function loadGroups(pageLimit, page, search) {
  return axios.get(`${apiUrl}/group?limit=${pageLimit}&offset=${page}&search=${search}`)
}

export function addGroup(data) {
  return axios.post(`${apiUrl}/group/create`, data)
}

export function getGroup(id) {
  return axios.get(`${apiUrl}/group/${id}`)
}

export function updateGroup(id, data) {
  return axios.put(`${apiUrl}/group/${id}`, data)
}

export function deleteGroup(id) {
  return axios.delete(`${apiUrl}/group/${id}`)
}

export function loadCapabilities() {
  return axios.get(`${apiUrl}/capabilities`)
}

export function resetUserPassword(id, data) {
  return axios.put(`${apiUrl}/user/reset-password/${id}`, data)
}

export function loadUserList(pageLimit, page, search) {
  return axios.get(`${apiUrl}/user/data/filter?limit=${pageLimit}&offset=${page}&search=${search}`)
}